import React from "react";
import isEqual from "lodash/isEqual";
import qs from "web/core/utils/queryString";
import baseTrackEvent from "theme/modules/Analytics/trackEvent";

const LIST_VIEWED = "Product List Viewed";
const LIST_FILTERED = "Product List Filtered";

const isFilterKey = (key) => ["page", "pageLength", "sort"].indexOf(key) === -1;
const activeFilters = (query) =>
  Object.keys(query)
    .filter(isFilterKey)
    .map((filter) => ({
      type: filter,
      value: Array.isArray(query[filter])
        ? query[filter].join(",")
        : query[filter],
    }));

export default (trackEvent = baseTrackEvent) => {
  return (BaseComponent) =>
    class withFilterableCategoryTracking extends React.Component {
      constructor() {
        super();
        this.track = this.track.bind(this);
        this.trackViewEvent = this.trackViewEvent.bind(this);
        this.trackFilterEvent = this.trackFilterEvent.bind(this);
        this.trackingCategoryPayload = this.trackingCategoryPayload.bind(this);
        this.sortingOrder = this.sortingOrder.bind(this);
        this.latestTrackedViewEvent = null;
        this.latestTrackedFilterEvent = null;
      }

      track() {
        if (this.props.loading) return;

        this.trackFilterEvent();
        this.trackViewEvent();
      }

      trackViewEvent() {
        const latest = this.latestTrackedViewEvent;
        const query = qs.parse(this.props.location.query);
        const eventQualificator = {
          type: LIST_VIEWED,
          page: this.props.page,
          categoryId: this.props.categoryId,
          filters: activeFilters(query),
          sort: this.sortingOrder(),
        };
        if (
          latest &&
          eventQualificator.page === latest.page &&
          eventQualificator.categoryId === latest.categoryId
        ) {
          return;
        }

        trackEvent(LIST_VIEWED, this.trackingCategoryPayload());
        this.latestTrackedViewEvent = eventQualificator;
      }

      trackFilterEvent() {
        const latest = this.latestTrackedFilterEvent;
        const latestView = this.latestTrackedViewEvent;
        const query = qs.parse(this.props.location.query);
        const eventQualificator = {
          type: LIST_FILTERED,
          filters: activeFilters(query),
          sort: this.sortingOrder(),
        };

        const allFilters = ({ filters, sort }) => filters.concat(sort);
        const latestViewTrackedHadFilters =
          latestView && allFilters(latestView).length > 0;

        if (
          (!allFilters(eventQualificator).length &&
            !latestViewTrackedHadFilters) ||
          (latest && isEqual(allFilters(eventQualificator), allFilters(latest)))
        ) {
          return;
        }

        // we only want to track a user action of filtering an already loaded page
        if (latestView) {
          trackEvent(LIST_FILTERED, {
            ...this.trackingCategoryPayload(),
            sorts: eventQualificator.sort,
            filters: eventQualificator.filters,
          });
        }

        this.latestTrackedFilterEvent = eventQualificator;
      }

      trackingCategoryPayload() {
        return {
          list_id: this.props.categoryId,
          category: this.props.category.name,
          products: this.props.category.layer.products.map((product) => ({
            sku: product.sku,
            category: this.props.category.name,
            name: product.name,
          })),
        };
      }

      sortingOrder() {
        return typeof this.props.sort === "undefined"
          ? []
          : [
              {
                type: this.props.sort.field,
                value:
                  this.props.sort.direction === "asc"
                    ? "ascending"
                    : "descending",
              },
            ];
      }

      componentDidMount() {
        this.track();
      }

      componentDidUpdate() {
        this.track();
      }

      render() {
        return <BaseComponent {...this.props} />;
      }
    };
};
